import { CONTENT_PROPERTIES, fetchCmpObjectsByType } from 'personalization-lib/api/clients/cmpApiClient';
import { PERSONALIZATION_STATUS } from 'personalization-lib/constants/status';
import { notHasProperty, propertyNotEquals } from 'personalization-lib/utils/assetData/cmp';
import { LANDING_PAGES_URL } from 'personalization-lib/constants/urls';
import { fetchContentById } from 'personalization-lib/api/clients/contentApiClient';
export const fetchLandingPage = id => fetchContentById({
  url: LANDING_PAGES_URL,
  id
});
export const LP_FILTERS = [notHasProperty(CONTENT_PROPERTIES.VARIATION), notHasProperty(CONTENT_PROPERTIES.AB_STATUS), notHasProperty(CONTENT_PROPERTIES.PERSONALIZATION_STRATEGY_ID), propertyNotEquals(CONTENT_PROPERTIES.PERSONALIZATION_VARIANT_STATUS, PERSONALIZATION_STATUS.VARIANT)];
export const fetchLandingPagesOptions = paginationParams => fetchCmpObjectsByType(Object.assign({
  objectType: 'LANDING_PAGE',
  filters: LP_FILTERS
}, paginationParams)).then(cmpPaginatedSearch => ({
  total: cmpPaginatedSearch.total,
  results: cmpPaginatedSearch.results.map(asset => ({
    text: asset.name,
    value: asset.id.toString(),
    screenshot: asset.imgSrc
  })),
  offset: cmpPaginatedSearch.offset
}));